export function initMainSiteNavigation() {
    var nav = document.querySelector(".block--main-navigation");
    if (!nav) return;

    var toggle = nav.querySelector(".main-navigation__mobile-toggle");
    var drawer = nav.querySelector(".main-navigation__mobile");
    var backBtn = nav.querySelector(".main-navigation__mobile-back");
    var closeBtn = nav.querySelector(".main-navigation__mobile-close");
    var sectionTriggers = Array.from(nav.querySelectorAll("[data-mobile-section-trigger]"));
    var sectionPanels = nav.querySelectorAll("[data-mobile-level='2']");
    var desktopPanels = Array.from(nav.querySelectorAll("[data-nav-panel]"));
    var desktopTriggers = Array.from(nav.querySelectorAll("[data-nav-section]"));
    var panelClip = nav.querySelector("[data-nav-panel-clip]");

    // ── Mobile ─────────────────────────────────────────────

    function openDrawer() {
        drawer.hidden = false;
        // rAF ensures the browser paints the element before the opacity transition starts
        requestAnimationFrame(function () {
            drawer.classList.add("is-open");
        });
        toggle.setAttribute("aria-expanded", "true");
        showLevel1();
    }

    function closeDrawer() {
        drawer.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
        drawer.addEventListener("transitionend", function onEnd() {
            drawer.hidden = true;
            drawer.removeEventListener("transitionend", onEnd);
        }, { once: true });
        showLevel1();
    }

    function showLevel1() {
        backBtn.hidden = true;
        sectionPanels.forEach(function (p) { p.hidden = true; });
        drawer.classList.remove("main-navigation__mobile--section-open");
    }

    function showLevel2(index) {
        backBtn.hidden = false;
        sectionPanels.forEach(function (p, i) { p.hidden = i !== index; });
        drawer.classList.add("main-navigation__mobile--section-open");
    }

    if (toggle) {
        toggle.addEventListener("click", function () {
            drawer.hidden ? openDrawer() : closeDrawer();
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", closeDrawer);
    }

    if (backBtn) {
        backBtn.addEventListener("click", showLevel1);
    }

    sectionTriggers.forEach(function (trigger, index) {
        trigger.addEventListener("click", function () {
            showLevel2(index);
        });
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !drawer.hidden) {
            closeDrawer();
            if (toggle) toggle.focus();
        }
    });

    var desktopQuery = window.matchMedia("(min-width: 992px)");
    var onDesktopChange = function (e) {
        if (e.matches) closeDrawer();
    };
    if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener("change", onDesktopChange);
    } else if (desktopQuery.addListener) {
        desktopQuery.addListener(onDesktopChange);
    }

    // ── Search panel ────────────────────────────────────────

    var searchTrigger = nav.querySelector("[data-nav-search-trigger]");
    var searchPanel = nav.querySelector("[data-nav-search-panel]");
    var searchInput = searchPanel && searchPanel.querySelector(".main-navigation__search-input");
    var searchInnerWrap = searchPanel && searchPanel.querySelector(".main-navigation__search-panel-inner-wrap");
    var searchCloseTimer = null;
    var backdrop = document.createElement("div");
    backdrop.className = "main-navigation__backdrop";
    backdrop.setAttribute("aria-hidden", "true");
    document.body.appendChild(backdrop);

    function openSearch() {
        closeAllPanels();
        if (searchCloseTimer) { clearTimeout(searchCloseTimer); searchCloseTimer = null; }
        var targetHeight = searchInnerWrap ? searchInnerWrap.scrollHeight : 0;
        searchPanel.style.height = targetHeight + "px";
        searchPanel.toggleAttribute("data-nav-search-open", true);
        searchTrigger.setAttribute("aria-expanded", "true");
        backdrop.classList.add("is-visible");
        if (searchInput) setTimeout(function () { searchInput.focus(); }, 80);
    }

    function closeSearch() {
        searchPanel.removeAttribute("data-nav-search-open");
        searchTrigger.setAttribute("aria-expanded", "false");
        searchCloseTimer = setTimeout(function () {
            searchPanel.style.height = "0";
            searchCloseTimer = null;
        }, 120);
        if (activePanel === null) backdrop.classList.remove("is-visible");
    }

    var searchClose = searchPanel && searchPanel.querySelector("[data-nav-search-close]");

    if (searchTrigger && searchPanel) {
        searchTrigger.addEventListener("click", function () {
            searchPanel.hasAttribute("data-nav-search-open") ? closeSearch() : openSearch();
        });

        if (searchClose) {
            searchClose.addEventListener("click", function () {
                closeSearch();
                searchTrigger.focus();
            });
        }

        searchPanel.addEventListener("keydown", function (e) {
            if (e.key === "Escape") {
                closeSearch();
                searchTrigger.focus();
            }
        });
    }

    // ── Desktop panels ──────────────────────────────────────

    var activePanel = null;
    var clipCloseTimer = null;
    var openPanelTimer = null;

    function getPanelHeight(index) {
        var panel = desktopPanels[index];
        if (!panel) return 0;
        var inner = panel.querySelector(".main-navigation__panel-inner");
        if (inner) return inner.scrollHeight;
        // Fallback: briefly make panel flow to measure
        panel.style.position = "relative";
        var h = panel.scrollHeight;
        panel.style.position = "";
        return h;
    }

    function openPanel(index) {
        if (searchPanel) closeSearch();
        if (clipCloseTimer) { clearTimeout(clipCloseTimer); clipCloseTimer = null; }
        if (openPanelTimer) { clearTimeout(openPanelTimer); openPanelTimer = null; }

        var switching = activePanel !== null && activePanel !== index;

        desktopPanels.forEach(function (p, i) {
            if (i !== index) p.removeAttribute("data-nav-panel-open");
        });

        desktopTriggers.forEach(function (t, i) {
            t.setAttribute("aria-expanded", i === index ? "true" : "false");
            t.setAttribute("aria-controls", "nav-panel-" + i);
        });

        if (panelClip) {
            var targetHeight = getPanelHeight(index);
            panelClip.style.height = targetHeight + "px";
            panelClip.toggleAttribute("data-nav-panel-clip-open", true);
            if (switching) {
                // Hide all other panels instantly so they don't overlap during swap
                desktopPanels.forEach(function (p, i) {
                    if (i !== index) {
                        p.style.transition = "none";
                        p.style.visibility = "hidden";
                        p.style.opacity = "0";
                        p.removeAttribute("data-nav-panel-open");
                    }
                });
                // Show new panel instantly — no fade when swapping
                desktopPanels[index].style.transition = "none";
                desktopPanels[index].style.visibility = "";
                desktopPanels[index].style.opacity = "";
                desktopPanels[index].toggleAttribute("data-nav-panel-open", true);
                // Restore transitions after paint so close can still fade
                requestAnimationFrame(function () {
                    desktopPanels.forEach(function (p) { p.style.transition = ""; });
                });
            } else {
                openPanelTimer = setTimeout(function () {
                    openPanelTimer = null;
                    if (activePanel === index) {
                        desktopPanels[index].toggleAttribute("data-nav-panel-open", true);
                    }
                }, 80);
            }
        } else {
            desktopPanels[index].toggleAttribute("data-nav-panel-open", true);
        }

        backdrop.classList.add("is-visible");
        activePanel = index;
    }

    function closeAllPanels() {
        if (openPanelTimer) { clearTimeout(openPanelTimer); openPanelTimer = null; }
        desktopPanels.forEach(function (p) {
            p.removeAttribute("data-nav-panel-open");
            p.style.transition = "";
            p.style.visibility = "";
            p.style.opacity = "";
        });
        desktopTriggers.forEach(function (t) { t.setAttribute("aria-expanded", "false"); });

        if (panelClip) {
            clipCloseTimer = setTimeout(function () {
                panelClip.style.height = "0";
                panelClip.removeAttribute("data-nav-panel-clip-open");
                clipCloseTimer = null;
            }, 120);
        }

        if (!searchPanel || !searchPanel.hasAttribute("data-nav-search-open")) {
            backdrop.classList.remove("is-visible");
        }
        activePanel = null;
    }

    if (backdrop) {
        backdrop.addEventListener("click", function () {
            closeAllPanels();
            closeSearch();
        });
    }

    // Give each panel an id so aria-controls resolves
    desktopPanels.forEach(function (p, i) {
        p.id = "nav-panel-" + i;
    });

    // Hover — open on mouseenter (after a short delay to avoid unintentional
    // triggers while passing over the menu), close when mouse leaves the nav+panel composite
    var hoverOpenTimer = null;
    desktopTriggers.forEach(function (trigger, index) {
        trigger.addEventListener("mouseenter", function () {
            if (hoverOpenTimer) clearTimeout(hoverOpenTimer);
            hoverOpenTimer = setTimeout(function () {
                hoverOpenTimer = null;
                openPanel(index);
            }, 200);
        });
        trigger.addEventListener("mouseleave", function () {
            if (hoverOpenTimer) {
                clearTimeout(hoverOpenTimer);
                hoverOpenTimer = null;
            }
        });
    });

    function isInsideNavOrClip(el) {
        return el && (nav.contains(el) || (panelClip && panelClip.contains(el)));
    }

    function onNavAreaMouseout(e) {
        if (!isInsideNavOrClip(e.relatedTarget)) {
            closeAllPanels();
            if (searchPanel && searchPanel.hasAttribute("data-nav-search-open")) closeSearch();
        }
    }

    nav.addEventListener("mouseout", onNavAreaMouseout);
    if (panelClip) panelClip.addEventListener("mouseout", onNavAreaMouseout);

    // Keyboard — Enter/Space opens panel and moves focus to first link
    desktopTriggers.forEach(function (trigger, index) {
        trigger.addEventListener("keydown", function (e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                if (activePanel === index) {
                    closeAllPanels();
                } else {
                    openPanel(index);
                    focusFirstPanelLink(index);
                }
            }
            // Arrow left/right moves between triggers
            if (e.key === "ArrowRight") {
                e.preventDefault();
                var next = (index + 1) % desktopTriggers.length;
                desktopTriggers[next].focus();
                openPanel(next);
            }
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                var prev = (index - 1 + desktopTriggers.length) % desktopTriggers.length;
                desktopTriggers[prev].focus();
                openPanel(prev);
            }
            // Arrow down moves into the open panel
            if (e.key === "ArrowDown") {
                e.preventDefault();
                openPanel(index);
                focusFirstPanelLink(index);
            }
        });
    });

    // Arrow up/down navigates within a panel; Escape closes and returns focus
    desktopPanels.forEach(function (panel, index) {
        panel.addEventListener("keydown", function (e) {
            var links = Array.from(panel.querySelectorAll("a, button"));
            var focused = document.activeElement;
            var focusedIndex = links.indexOf(focused);

            if (e.key === "ArrowDown") {
                e.preventDefault();
                var next = links[(focusedIndex + 1) % links.length];
                if (next) next.focus();
            }
            if (e.key === "ArrowUp") {
                e.preventDefault();
                if (focusedIndex === 0) {
                    // Back to trigger
                    closeAllPanels();
                    desktopTriggers[index].focus();
                } else {
                    var prev = links[focusedIndex - 1];
                    if (prev) prev.focus();
                }
            }
            if (e.key === "Escape") {
                closeAllPanels();
                desktopTriggers[index].focus();
            }
            // Tab closes the panel and lets focus leave naturally
            if (e.key === "Tab") {
                closeAllPanels();
            }
        });
    });

    function focusFirstPanelLink(index) {
        var panel = desktopPanels[index];
        if (!panel) return;
        var first = panel.querySelector("a, button");
        if (first) first.focus();
    }

    // Global Escape
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && activePanel !== null) {
            var current = activePanel;
            closeAllPanels();
            desktopTriggers[current].focus();
        }
    });
}
